import type { AsyncSequence, Bytes } from "@pdfking/tfunc"

// Input parameters for PDFReader

export type PDFReaderOptions = {
  stream: AsyncSequence<Blob>
  size: Bytes
  password?: string
}
